/* PILSNERISH OS — MAIL.EXE (sections/pz-newsletter.liquid)
 * Shared by the home section and the MAIL.EXE modal (snippets/pz-mail-modal.liquid, assets/pz-mail-modal.js).
 * [CANCEL] jumps away from the mouse inside the window. Keyboard focus/activation keeps it in place and it closes nothing.
 * QA preview: ?pz_mail=ok (success) or ?pz_mail=err (error) renders a state without posting the form.
 */
(function () {
  'use strict';
  var w = window, d = document;
  var PZ = w.PZ || (w.PZ = {});
  if (PZ.mailDialog) return; /* loaded by the section and by the modal snippet: run once */
  var QUIPS = ['CANCEL FAILED. NICE TRY.', 'ERR: CANCEL.EXE NOT FOUND', 'NO.', 'CANCEL IS NOT AN OPTION', 'STILL READY.'];
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    var form = root.querySelector('form');
    var win = root.querySelector('.pz-nl__win');
    var body = root.querySelector('.pz-nl__body');
    var main = root.querySelector('[data-nl-main]');
    var ok = root.querySelector('[data-nl-ok]');
    var btn = root.querySelector('[data-nl-cancel]');
    var send = root.querySelector('.pz-nl__send');
    var input = root.querySelector('.pz-nl__input');
    var err = root.querySelector('[data-nl-err]');
    var errMsg = root.querySelector('[data-nl-errmsg]');
    var status = root.querySelector('[data-nl-status]');
    var head = root.querySelector('.pz-nl__head');
    var icon = root.querySelector('.pz-nl__icon');
    var busyT = 0;
    if (!form || !win || !btn) return null;
    var ox = 0, oy = 0, quip = 0, lastJump = 0;

    function say(text, red) {
      if (!status) return;
      status.textContent = '';
      var s = d.createElement('span');
      if (red) s.className = 'pz-red';
      s.textContent = text;
      status.appendChild(s);
      if (PZ.scramble) PZ.scramble(s, { accent: red ? 'var(--ink)' : 'var(--red)' });
    }
    function showOk() {
      if (main) main.hidden = true;
      if (ok) ok.hidden = false;
      say('1 NEW MESSAGE');
      var h = ok && ok.querySelector('[data-nl-okhead]');
      if (h && PZ.scramble) PZ.scramble(h, { accent: 'var(--red)', duration: 520 });
    }
    function showErr(msg) {
      if (err) err.hidden = false;
      if (errMsg) errMsg.textContent = msg;
      if (input) { input.classList.add('is-err'); input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', err ? err.id : ''); }
      say('CONNECTION REFUSED', true);
    }
    function clearErr() {
      if (err) err.hidden = true;
      if (input) { input.classList.remove('is-err'); input.removeAttribute('aria-invalid'); }
    }

    /* ---------- the dodge ---------- */
    function home() { ox = oy = 0; btn.style.transform = ''; btn.classList.remove('is-fled'); }
    function rectsHit(a, b, m) { return !(a.right + m < b.left || a.left - m > b.right || a.bottom + m < b.top || a.top - m > b.bottom); }
    function jump(px, py) {
      var now = performance.now();
      if (now - lastJump < 90) return;
      lastJump = now;
      var br = body.getBoundingClientRect(), bb = btn.getBoundingClientRect();
      var hx = bb.left - ox, hy = bb.top - oy, bw = bb.width, bh = bb.height;
      function rects(list) { return list.filter(Boolean).map(function (el) { return el.getBoundingClientRect(); }); }
      var must = rects([send, input && input.parentNode]), nice = rects([head, icon, err && !err.hidden ? err : null]);
      var best = null, bd = -1, pad = 10;
      for (var pass = 0; pass < 2 && !best; pass++) {
        var avoid = pass ? must : must.concat(nice);
        for (var i = 0; i < 40; i++) {
          var x = br.left + pad + Math.random() * Math.max(0, br.width - bw - pad * 2);
          var y = br.top + pad + Math.random() * Math.max(0, br.height - bh - pad * 2);
          var r = { left: x, top: y, right: x + bw, bottom: y + bh };
          if (avoid.some(function (a) { return rectsHit(r, a, 6); })) continue;
          if (Math.hypot(x + bw / 2 - px, y + bh / 2 - py) < 90) continue;
          var dd = Math.hypot(x + bw / 2 - px, y + bh / 2 - py) * (0.6 + Math.random() * 0.8);
          if (dd > bd) { bd = dd; best = r; }
        }
      }
      if (!best) return;
      ox = best.left - hx; oy = best.top - hy;
      btn.style.transform = 'translate(' + Math.round(ox) + 'px,' + Math.round(oy) + 'px)';
      btn.classList.add('is-fled');
    }
    function near(e) {
      var r = btn.getBoundingClientRect();
      var dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right), dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
      return Math.hypot(dx, dy);
    }
    function onMove(e) {
      if (e.pointerType !== 'mouse' || (main && main.hidden)) return;
      if (near(e) < 44) jump(e.clientX, e.clientY);
    }
    function onBtnDown(e) {
      if (e.pointerType === 'mouse') { e.preventDefault(); jump(e.clientX, e.clientY); return; }
      /* touch/pen: it bails right after the tap */
      var x = e.clientX, y = e.clientY;
      setTimeout(function () { jump(x, y); }, 160);
    }
    function onClick(e) {
      e.preventDefault();
      say(QUIPS[quip++ % QUIPS.length], true);
    }
    function onFocus() {
      /* keyboard users get a normal, stationary button */
      try { if (btn.matches(':focus-visible')) home(); } catch (err2) { home(); }
    }
    function onLeave() { /* stay where it fled; the joke is that it never comes back */ }
    win.addEventListener('pointermove', onMove);
    win.addEventListener('pointerleave', onLeave);
    btn.addEventListener('pointerdown', onBtnDown);
    btn.addEventListener('click', onClick);
    btn.addEventListener('focus', onFocus);

    /* ---------- submit ----------
       Validate on the button's click (Enter in the field fires it too), so an invalid address never starts a
       submission and never wakes Shopify's captcha. A valid one goes through the normal customer form post. */
    function onSendClick(e) {
      var v = input ? input.value.trim() : '';
      if (!EMAIL.test(v)) {
        e.preventDefault();
        showErr(v ? 'that does not look like an email.' : 'type an email first.');
        if (input) input.focus();
        return;
      }
      clearErr();
      say('DIALING...');
      setTimeout(function () { if (send) { send.classList.add('is-busy'); send.textContent = '[DIALING...]'; } }, 0);
      /* if the store's captcha is dismissed we are still here: hang up */
      clearTimeout(busyT);
      busyT = setTimeout(function () {
        if (send) { send.classList.remove('is-busy'); send.textContent = '[SUBSCRIBE]'; }
        say('NO CARRIER', true);
      }, 9000);
    }
    function onInput() { if (err && !err.hidden) clearErr(); if (status && status.textContent !== 'READY.') status.textContent = 'READY.'; }
    if (send) send.addEventListener('click', onSendClick);
    if (input) input.addEventListener('input', onInput);

    /* ---------- states ---------- */
    var q = '';
    try { q = new URLSearchParams(w.location.search).get('pz_mail') || ''; } catch (e3) {}
    if (q === 'ok') showOk();
    else if (q === 'err') showErr('Email is invalid.');
    else if (ok && !ok.hidden) {
      /* real post-back: land on the dialog */
      var h = ok.querySelector('[data-nl-okhead]');
      if (PZ.scramble && h) PZ.scramble(h, { accent: 'var(--red)', duration: 520 });
    }

    return function () {
      win.removeEventListener('pointermove', onMove);
      win.removeEventListener('pointerleave', onLeave);
      btn.removeEventListener('pointerdown', onBtnDown);
      btn.removeEventListener('click', onClick);
      btn.removeEventListener('focus', onFocus);
      if (send) send.removeEventListener('click', onSendClick);
      if (input) input.removeEventListener('input', onInput);
      clearTimeout(busyT);
      home();
    };
  }

  PZ.mailDialog = init;
  if (PZ.onSection) PZ.onSection('newsletter', init);
  else d.addEventListener('DOMContentLoaded', function () { [].forEach.call(d.querySelectorAll('[data-pz-section="newsletter"]'), init); });
})();
